import React, { useCallback, memo } from "react";
import { Grid, AutoSizer } from "react-virtualized";
import {
    CustomRoundPlusIcon,
    CustomSquareMinusIcon,
} from "../TickersPickerModal/tickersPickerModalStyles";
import style from "./tpv.module.scss";

export interface TickerPickerViewProps {
    data: string[];
    type: TickerPickerViewType;
    onIconClick: Function;
}

export type TickerPickerViewType = "available" | "picked";

const borderColor = "#eee";

const border = {
    borderBottom: `1px solid ${borderColor}`,
};

const flex = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};

const TickerPickerView = ({
    data,
    type,
    onIconClick,
}: TickerPickerViewProps) => {
    const cellRenderer = ({ columnIndex, key, rowIndex, style, parent }) => {
        const name = data[rowIndex];
        const _key = `ticker-picker-view-item-${key}`;
        const onClick = () => onIconClick(name);
        const cell_style = {
            ...style,
            ...flex,
            ...border,
            overflow: "hidden",
        };
        if (columnIndex !== 0) {
            return (
                <div style={cell_style} key={_key}>
                    {type === "available" ? (
                        <CustomRoundPlusIcon />
                    ) : (
                        <CustomSquareMinusIcon />
                    )}
                    <div
                        //@ts-ignore
                        onClick={onClick}
                        style={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                        }}
                    ></div>
                </div>
            );
        }

        return (
            <div
                key={_key}
                style={{
                    ...cell_style,
                    justifyContent: "flex-start",
                    borderRight: `1px solid ${borderColor}`,
                    boxSizing: "border-box",
                }}
            >
                <span
                    style={{
                        paddingLeft: "10px",
                    }}
                >
                    {name}
                </span>
            </div>
        );
    };

    const memo_renderer = useCallback(cellRenderer, [data.length]);

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <AutoSizer>
                {({ width, height }) => {
                    let _width = width + 3;
                    const column_width = [
                        (_width / 100) * 84,
                        (_width / 100) * 16,
                    ];
                    // if (type === "picked") {
                    //     column_width[0] = (_width / 100) * 80;

                    // }
                    return (
                        <>
                            <Grid
                                className={style.grid}
                                width={_width}
                                height={height}
                                rowHeight={35}
                                rowCount={data.length}
                                columnCount={2}
                                columnWidth={(x) => column_width[x.index]}
                                cellRenderer={memo_renderer}
                            />
                        </>
                    );
                }}
            </AutoSizer>
        </div>
    );
};

export default memo(TickerPickerView);
